"use client";

import { useUser } from "@clerk/nextjs";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

import { Spreadsheets } from "@/app/_components/spreadsheets";

import { getUserPlanByMetadata } from "@/helper/user/client";

import type { Uf } from "@/types";

interface Props extends Uf {
  children: React.ReactNode;
}

export const DownloadList = ({ children, uf }: Props) => {
  const { user } = useUser();
  const { hasPaidPlan } = getUserPlanByMetadata(user?.publicMetadata);

  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="overflow-auto w-full sm:max-w-2xl h-full sm:max-h-[95%] sm:min-h-[400px] sm:h-auto">
        <DialogHeader>
          <DialogTitle>Baixar planilha de imóveis</DialogTitle>
          <DialogDescription>
            Filtre por estado e visualize todos os detalhes dos imóveis de
            leilão em uma planilha prática, segura e fácil de usar.
          </DialogDescription>
          <div className="pt-6">
            <Spreadsheets premium={hasPaidPlan} enabled={hasPaidPlan} uf={uf} />
          </div>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};
